import classNames from 'classnames';
import { CommonCard } from '../../../../../components/card';
import { CommonPrompt } from '../../../../../components/prompt';
import { moneyChinese } from '../../../../../lib';
import getFormatMessage from '../../../../../locales/get-format-message';
import { InvoiceType } from '../../../../../model/api-modules';
import styles from './index.module.scss';

interface IProps {
  readonly invoiceType: InvoiceType;
  readonly buyerName: string;
  readonly buyerCode: string;
  readonly buyerBank: string;
  readonly buyerBankCode: string;
  readonly amount: number;
  readonly remark?: string;
  readonly unit: string;
  readonly spec: string;
  readonly showBuyer: boolean;
  readonly showSeller: boolean;
}

export const InvoicePreview = (props: IProps) => {
  const { showBuyer, showSeller, invoiceType } = props;
  const price = Number((props.amount / 1.06).toFixed(2));
  return (
    <div className={styles.previewPage}>
      <CommonPrompt>
        <div>{getFormatMessage('invoice_preview_info_1')}</div>
        <div>{getFormatMessage('invoice_preview_info_2')}</div>
      </CommonPrompt>

      <CommonCard>
        <div className={styles.invoicePreview}>
          <div className={styles.title}>
            <div className={styles.squares}>
              <div className={styles.codeSquare}>二维码</div>
              <div className={styles.tagSquare}>标签</div>
            </div>
            <div className={styles.titleCenter}>
              <div>
                电子发票 （
                {invoiceType === InvoiceType.Special ? '专用发票' : '普通发票'}
                ）
              </div>
              <div></div>
            </div>
            <div className={styles.titleRight}>
              <span>
                发票号码:
                <span className={styles.commonContent}>
                  以实际开出的发票为准
                </span>
              </span>
              <span>
                开票日期:
                <span className={styles.commonContent}>
                  以实际开出的发票为准
                </span>
              </span>
            </div>
          </div>
          <div className={styles.body}>
            <div className={styles.itemLabel}>
              <span>购买方信息</span>
            </div>
            <div className={styles.flexCenterContent}>
              {
                <>
                  <div>
                    名称:
                    <span className={styles.commonContent}>
                      {props.buyerName}
                    </span>
                  </div>
                  <div>
                    统一社会信用代码/纳税人识别号:
                    <span className={styles.commonContent}>
                      {props.buyerCode}
                    </span>
                  </div>
                </>
              }
            </div>
            <div className={styles.itemLabel}>销售方信息</div>
            <div className={styles.flexCenterContent}>
              {
                <>
                  <div>
                    名称:
                    <span className={styles.commonContent}>
                      深圳市腾讯计算机系统有限公司
                    </span>
                  </div>
                  <div>
                    统一社会信用代码/纳税人识别号:
                    <span className={styles.commonContent}>
                      91440300708461136T
                    </span>
                  </div>
                </>
              }
            </div>
            <div className={styles.centerCell}>
              <div>项目名称</div>
              <div>规格型号</div>
              <div>单 位</div>
              <div>数 量</div>
              <div>单 价</div>
              <div>金 额</div>
              <div>税率/征收率</div>
              <div>税额</div>

              <div>*信息技术服务*技术服务</div>
              <div>{props.spec === '空白' ? '' : props.spec}</div>
              <div>{props.unit}</div>
              <div>1</div>
              <div>{price}</div>
              <div>{price}</div>
              <div>6%</div>
              <div>{(props.amount - price).toFixed(2)}</div>

              {[1, 1, 1, 1].map(() => {
                return (
                  <>
                    <div> </div>
                    <div> </div>
                    <div> </div>
                    <div> </div>
                    <div> </div>
                    <div> </div>
                    <div> </div>
                    <div> </div>
                  </>
                );
              })}
              <div className={styles.totalCell}>合 计</div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div>{price}</div>
              <div></div>
              <div>{(props.amount - price).toFixed(2)}</div>
            </div>
            <div className={styles.moneySummary}>
              <div className={styles.chineseMoneyLabel}>价税合计（大写）</div>
              <div className={styles.chineseMoneyVal}>
                <span className={styles.commonContent}>
                  <span>⨂</span>
                  {moneyChinese(props.amount)}
                </span>
                <span>
                  （小写）
                  <span className={styles.commonContent}>¥{props.amount}</span>
                </span>
              </div>
            </div>
            <div className={styles.itemLabel}>备注</div>
            <div>
              <div className={styles.remarkBanks}>
                {showBuyer && (
                  <>
                    <div>
                      {getFormatMessage('购方开户银行')}:
                      <span className={styles.commonContent}>
                        {props.buyerBank}
                      </span>
                    </div>
                    <div>
                      {getFormatMessage('银行账号')}:
                      <span className={styles.commonContent}>
                        {props.buyerBankCode}；
                      </span>
                    </div>
                  </>
                )}
                {showSeller && (
                  <>
                    <div>
                      {getFormatMessage('销方开户银行')}:
                      <span className={styles.commonContent}>
                        招商银行北京分行上地支行
                      </span>
                    </div>
                    <div>
                      {getFormatMessage('银行账号')}:
                      <span className={styles.commonContent}>
                        8172818239100014；
                      </span>
                    </div>
                  </>
                )}
              </div>
              <div
                className={classNames(
                  styles.commonContent,
                  styles.remarkContent
                )}
              >
                {props.remark || ''}
              </div>
            </div>
          </div>

          <div className={styles.footer}>
            开票人：
            <span className={styles.commonContent}>以实际开出的发票为准</span>
          </div>
        </div>
      </CommonCard>
    </div>
  );
};
